import {
  Box,
  Card,
  Typography,
  Container,
  Button,
  FormControl,
} from "@mui/material";

import { styled } from "@mui/material/styles";

const MainContent = styled(Box)(
  ({ theme }) => `
      height: 100%;
      display: flex;
      flex: 1;
      overflow: auto;
      flex-direction: column;
      align-items: center;
      justify-content: center;
  `,
);

function AuthPrompt({ authState, signIn }) {
  return (
    <MainContent>
      <Container maxWidth="sm">
        <Card sx={{ textAlign: "center", mt: 3, p: 4 }}>
          <FormControl variant="outlined" fullWidth>
            <Typography
              variant="h4"
              color="text.secondary"
              fontWeight="bold"
              sx={{ mb: 4 }}
            >
              Login to Access Prizeet Admin Platform
            </Typography>
          </FormControl>
          <Button style={{ marginRight: "10px" }} href="#" disabled={authState.loading} onClick={signIn}
                  variant="contained">
            Login with Google
          </Button>
        </Card>
      </Container>
    </MainContent>
  );
}

export default AuthPrompt;
